import { RadioButton } from "components/common/RadioButton";
import { ONE, ZERO } from "domain/aboutYourLoan";
import { Nullable } from "util/extendedTypes";
import {
  REPAYMENT_TERM_RADIO_QUESTION,
  REPAYMENT_TERM_RADIO_OPTION1,
  REPAYMENT_TERM_RADIO_OPTION2,
} from "./YourLoan.const";

type CIRHQuestionsProps = {
  CIRHTaken?: Nullable<number>;
  onChange: (v: number) => void;
};
export const CIRHQuestions = ({ CIRHTaken, onChange }: CIRHQuestionsProps) => {
  return (
    <fieldset>
      <label id="CIRHOptions" className="title">
        {REPAYMENT_TERM_RADIO_QUESTION}
      </label>
      <div className="customLabelRawRadios">
        <RadioButton
          name="CIRHOptions"
          label={REPAYMENT_TERM_RADIO_OPTION1}
          isSelected={CIRHTaken === ZERO}
          onChange={() => {
            onChange(ZERO);
          }}
          disabled={false}
        />
        <RadioButton
          name="CIRHOptions"
          label={REPAYMENT_TERM_RADIO_OPTION2}
          isSelected={CIRHTaken === ONE}
          onChange={() => {
            onChange(ONE);
          }}
          disabled={false}
        />
        <br />
      </div>
    </fieldset>
  );
};
